import { render, staticRenderFns } from "./DistributorNews.vue?vue&type=template&id=1b8778e2&scoped=true"
import script from "./DistributorNews.vue?vue&type=script&lang=js"
export * from "./DistributorNews.vue?vue&type=script&lang=js"
import style0 from "./DistributorNews.vue?vue&type=style&index=0&id=1b8778e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8778e2",
  null
  
)

export default component.exports